<template>
  <div id="indicador-equipe">
    <div class="header-indicador">
      <h5>Indicador de Apontamento de Horas</h5>
    </div>
    <div class="body-indicador">
      <div>
        <div v-for="indicador in indicadores" v-bind:key="indicador.usuario_id" class="card-indicador">
          <div class="image">
            <img 
              :src="`http://gitlab.meta.com.br/uploads/-/system/user/avatar/${indicador.usuario_gitlab_id}/avatar.png`" 
              onerror="this.src='img/default-user.png'" 
            />
          </div>
          <div class="column-details">
            <div class="name">{{ indicador.name }}</div>
            <div class="progress-item">
              <progress-bar :total="indicador.total" :current="indicador.duracao"></progress-bar>
              <div>{{ getDuracao(indicador.duracao) }} de {{ getDuracao(indicador.total) }}</div>
            </div>
          </div>
          <div class="details" v-on:click="abrirDetalhesUsuario(indicador.usuario_id)">
            <i class="fa fa-external-link" aria-hidden="true" title="Abrir detalhes"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  #indicador-equipe {
    background: white;
    border-radius: 15px;
    box-shadow: 1px 1px 4px 0px #b7b7b7;

    .header-indicador {
      background-color: #eaeaea;
      padding: 10px;

      h5 { margin: 0; }
    }

    .body-indicador {
      background-color: #f7f7f7;
      padding: 15px;

      .card-indicador {
        display: flex;
        padding: 10px;
        border-radius: 10px;
        background-color: #fdfdfd;
        box-shadow: 0px 1px 4px 0px #b3b3b3;
        margin-bottom: 10px;

        .image {
          padding-right: 10px;
          border-right: 1px solid #ccc;
          margin-right: 10px;
          
          img {
            height: 100px;
            width: 100px;
            border: 1px solid #ccc;
            border-radius: 11px;
          }
        }

        .column-details {
          flex: 3;

          .name {
            font-size: 1.2rem;
            margin-bottom: 5px;
          }
        }

        .details {
          flex: 1;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;

          i {
            font-size: 1.5rem;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>


<script>
import Card from '../templates/Card';
import ProgressBar from '../templates/ProgressBar';
import Utils from '@/mixins/utils';
import sortBy from 'lodash/sortBy';

export default {
  name: 'indicador-equipe',

  mixins: [
    Utils,
  ],

  components: {
    Card,
    ProgressBar,
  },

  data() {
    return {
      indicadores: [],
      diferencaDatas: 7,
      carregando: false,
    };
  },

  computed: {
    fimPeriodo() {
      const data = new Date().toISOString().slice(0,10);
      return new Date(`${data} 09:00:00`);
    },
  },

  watch: {
    diferencaDatas() {
      this.getIndicador();
    },
  },

  mounted() {
    this.getIndicador();
  },

  methods: {
    async getIndicador() {
      try {
        this.carregando = true;

        const dto = this.getDatas();
        const { data: response } = await this.$http.get('/dashboard/apontamentos', { params: dto });
        const diferenca = this.diferencaDatas - this.getFolgasEntrePeriodos(1);

        response.registros.map((item) => {
          const periodoExecutado = this.getPeriodoExecutado(item.horas_liberadas);
          item.total = (item.horas_liberadas * diferenca) + periodoExecutado;
        });

        this.indicadores = sortBy(response.registros, o => ((o.duracao * 100) / o.total));
      } catch(e) {
        console.error(e);
      } finally {
        this.carregando = false;
      }
    },

    getDatas() {
      const dt_fim = new Date().toISOString().slice(0, 10);
      const dt_inicio = this.removerDias(new Date(), this.diferencaDatas - 1).toISOString().slice(0, 10);

      return { dt_fim, dt_inicio };
    },

    getFolgasEntrePeriodos(inicial = 0) {
      // Não contabiliza dia completo atual
      let folgas = inicial;

      for(let i = 0; i < this.diferencaDatas; i++) {
        const data = this.removerDias(new Date(), i);
        const diaSemana = new Date(data).getDay();

        if (diaSemana === 0 || diaSemana === 6) {
          folgas++;
        }
      }

      return folgas;
    },

    getPeriodoExecutado(horasLiberadas) {
      const diaSemana = new Date().getDay();
      const hora = new Date().getHours();

      if (diaSemana === 0 || diaSemana === 6) {
        return 0;
      }

      const percorrido = (Math.abs(new Date(this.fimPeriodo) - new Date()) / 36e5);

      if (hora >= 10 + (horasLiberadas / 3600)) {
        return horasLiberadas;
      }

      return (hora > 12 ? percorrido - 1 : percorrido) * 3600;
    },

    abrirDetalhesUsuario(idUsuario) {
      this.$router.push({ path: `/horas/historico/${idUsuario}` })
    }
  }
}

</script>
